import classNames from "classnames";

export const CardFrame = ({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={classNames(
        "tw:flex tw:flex-col tw:gap-2 tw:justify-center tw:items-center tw:w-full",
        "tw:mt-[21px] tw:px-4 tw:pb-4",
        "tw:rounded-[20px] tw:!shadow-gray-100 tw:!shadow-md",
        "tw:border-1! tw:border-gray-100!",
        "tw:cursor-pointer",
        className,
      )}
    >
      <div className={classNames("tw:w-full")}>{children}</div>
    </div>
  );
};
